<template>
	<div class="m-portlet m-portlet--mobile">
		<div class="form-group m-form__group col-md-4 col-sm-12">
			<div class="input-group">
				<input v-model="username" type="text" class="form-control" placeholder="Tên tài khoản">
				<div class="input-group-append">
					<button @click="onCheckAcc" class="btn btn-brand" type="button">Tìm</button>
				</div>
			</div>
		</div>
		<div class="device-detail form-group m-form__group col-12" v-if="displayDetail">
			<div class="m-radio-inline">
				<label class="m-radio">
					<input disabled type="radio" name="device" value="2" v-model="device"> Android
					<span></span>
				</label>
				<label class="m-radio">
					<input disabled type="radio" name="device" value="1" v-model="device"> IOS
					<span></span>
				</label>
			</div>
			<button :disabled="disableState" @click="onChangeDevice" type="button" class="btn btn-brand m-btn m-btn--custom">Chuyển server</button>
		</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import { Utilities } from '../../utilities';

	export default {
		data(){
			let vm = this;

	        return {
	        	"username": "",
	        	"displayDetail": false,
	        	"disableState": false,
	        	"device": ""
	        }
	    },

	    methods: {
	        onCheckAcc: function(){
	        	let vm = this;
	        	if(this.username == ""){
	        		swal("Lỗi", "Tên tài khoản không được để trống", "error");
	        		return;
	        	}

				this.displayDetail = false;
				
	        	window.axios.get("partner/check/"+this.username)
        				.then((res) => {
        					if(res.data.code != 0){
        						swal("Lỗi", res.data.msg, "error");
        						return;
        					}
        					
        					vm.displayDetail = true;

        					if(!res.data.data.allow_device_android && !res.data.data.allow_device_ios){
        						vm.disableState = "disabled";
        					}

        					if(res.data.data.allow_device_android === true){
        						vm.device = "2";
        						vm.disableState = false;
        					}

        					if(res.data.data.allow_device_ios === true){
        						vm.device = "1";
        						vm.disableState = false;
        					}
        				})
        				.catch((error) => {
        					swal("", "Có lỗi xảy ra", "error");
        				});
	        },
	        onChangeDevice: function(){
				let vm = this;
				if(this.device == "") return;
				
				mApp.blockPage({
					overlayColor: '#000000',
					type: 'loader',
					state: 'primary',
					message: 'Đang xử lý...'
				});
				
	        	window.axios.put("partner/change-device/"+this.username+"/"+this.device)
        				.then((res) => {
							mApp.unblockPage();
        					if(res.data.code != 0){
        						swal("Lỗi", res.data.msg, "error");
        						return;
        					}
        					
							swal("", "Chuyển thành công", "success");
							vm.displayDetail = false;
        				})
        				.catch((error) => {
							mApp.unblockPage();
        					swal("", "Có lỗi xảy ra", "error");
        				});
	        }
	    }
	}

</script>